<!--
  lovi
  注册 2020-1-8
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="noShadow"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper logReg-field">
      <h3>{{ $t("logReg.accountRegistration") }}</h3>
      <ul>
        <li>
          <van-cell-group>
            <van-field
              clearable
              left-icon="icon-name"
              v-model="reginfo.username"
              :error="error.username ? true : false"
              @input="changeUsername"
              :placeholder="$t('common.AccountFormat')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-cell-group>
            <van-field
              clearable
              left-icon="icon-lock"
              :right-icon="eye ? 'eye-o' : 'closed-eye'"
              @click-right-icon="eye = !eye"
              :type="eye ? 'text' : 'password'"
              v-model="reginfo.password"
              :error="error.password ? true : false"
              @input="changePassword"
              :placeholder="$t('common.PasswordFormat')"
            />
          </van-cell-group>
        </li>
        <li>
          <van-button
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="submit"
          >
            {{ flag == "third" ? $t("common.confirm") : $t("common.register") }}
          </van-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import * as validate from "@/commonJs/validate.js";
export default {
  name: "reg",
  meta: {
    power: false,
    service: false
  },
  components: {},
  data() {
    return {
      flag: "",
      routeData: {}, //路由数据
      btnLoading: false, //按钮loadding
      inviteesId: "",
      eye: false,
      reginfo: {
        username: "",
        password: ""
      },
      error: {
        username: false,
        password: false
      }
    };
  },
  created() {
    let vm = this;
    vm.flag = vm.$route.query.flag;
    if (vm.flag == "third") {
      if (_.isEmpty(vm.$route.params)) {
        // 刷新页面要返回
        vm._back();
      } else {
        vm.routeData = vm.$route.params;
      }
      console.log("routeData", vm.routeData);
    }
    // 邀请注册人ID
    vm.inviteesId = vm.$route.query.id || "";
  },
  mounted() {},
  computed: {},
  methods: {
    changeUsername() {
      // 账号
      this.error.username = validate.validateUserName(this.reginfo.username);
    },
    changePassword() {
      // 验证密码
      this.error.password = validate.validatePsd(this.reginfo.password);
    },
    submit() {
      // 提交
      let vm = this;
      for (let key in vm.error) {
        if (vm.error[key]) {
          vm.$toast(vm.error[key]);
          return false;
        }
      }
      if (vm.reginfo.username == "") {
        vm.$toast(vm.$t("common.enterAccount"));
        return false;
      }
      if (vm.reginfo.password == "") {
        vm.$toast(vm.$t("common.enterPassword"));
        return false;
      }
      vm.registerCheck(vm.reginfo);
    },
    registerCheck(data) {
      // 验证注册账号
      let vm = this;
      vm.btnLoading = true;
      vm.$post("/app/user/registerCheck", data, { alert: true }).then(res => {
        vm.btnLoading = false;
        console.log("registerCheck", res);
        if (res.code == 0) {
          let params = {};
          params.username = vm.reginfo.username;
          params.password = vm.reginfo.password;
          params.mark = vm.routeData.mark;
          params.nickname = vm.routeData.nickname;
          params.Invitees_id = vm.inviteesId;
          vm.$router.push({
            path: "/mobile",
            name: "mobile",
            query: { flag: "reg" },
            params: params
          });
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped></style>
